import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-analise-dados',
  templateUrl: './analise-dados.component.html',
  styleUrls: ['./analise-dados.component.scss']
})
export class AnaliseDadosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
